import React, { useState } from "react";
import {
	AppShell,
	Text,
	MediaQuery,
	useMantineTheme,
	Grid,
	Image,
	Button,
	Group,
	Container,
	TextInput,
	Center,
	NativeSelect,
	Loader,
} from "@mantine/core";
import { showErrorNotification } from "../../utils/Notifications";
import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
import Headr from "../../components/Headr";
import Footr from "../../components/Footr";
import Duser from "../../static/svg/Duser.svg";
import { IconChevronDown } from "@tabler/icons";
import TeamManagement from "./TeamManagement";
import InviteUser from "../../API/inviteUser";
function Adduser() {
	const [loading, setLoading] = useState(false);
	const accountId = useSelector(
		(state) => state.userInformationReducer.users.AccountId
	);

	const theme = useMantineTheme();
	const form = useForm({
		initialValues: {
			Email: "",
			FirstName: "",
			LastName: "",
			Role: "",
			UserId: accountId,
		},
		validate: {
			Email: (value) =>
				/^\S+@\S+$/.test(value) ? null : "Invalid email",
		},
	});
	const inviteUserHandler = form.onSubmit(async (addUser) => {
		setLoading(true);
		if (addUser.Role === "Admin") {
			addUser.Role = 2;
		}
		if (addUser.Role === "Viewer") {
			addUser.Role = 4;
		}
		if (addUser.Role === "Creator") {
			addUser.Role = 3;
		}
		const result = await InviteUser(addUser);
		setLoading(false);
		if (result === "Email already exist") {
			form.reset();
			setLoading(false);
			showErrorNotification("Email already exist");
		}
		if (result.message === "Success") {
			form.reset();
			setLoading(false);
		}
	});
	return (
		<AppShell
			styles={{
				main: {
					paddingTop: "10px",
					minHeight: "calc(100vh - 100px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
			header={<Headr />}
		>
			<Container
				size="100%"
				shadow="sm"
				p="xl"
				position="left"
				style={{
					background: "#09254E",
					borderRadius: "5px",
					flexDirection: "column",
				}}
				className="adduser-container"
			>
				<Group style={{ display: "block" }}>
					<Text
						weight={700}
						style={{ fontSize: "25px", color: "#FFFFFF" }}
					>
						Add User
					</Text>

					<Text style={{ fontSize: "57%" }} color={"#FFFFFF"}>
						You can add your core teams in just 4 steps. Add users
						and manage their roles to set up a team on IVISIT
						platform.
					</Text>
				</Group>
				<form onSubmit={inviteUserHandler}>
					<Grid grow>
						<Grid.Col sm={1} lg={2}>
							<MediaQuery
								smallerThan="sm"
								styles={{ width: "100px" }}
							>
								<Image src={Duser} pt={7} width={100} />
							</MediaQuery>
						</Grid.Col>
						<Grid.Col sm={6} lg={5}>
							<Center mt="xm" pl={0} ml={0}>
								<TextInput
									className="labelAddUser"
									mr={10}
									placeholder="First Name"
									label="FirstName"
									{...form.getInputProps("FirstName")}
									styles={{
										input: {
											backgroundColor: "#294165",
											color: "white",
										},
										root: {
											width: "50%",
											color: "white",
										},
									}}
								/>

								<TextInput
									className="labelAddUser"
									placeholder="Last Name"
									label="LastName"
									{...form.getInputProps("LastName")}
									styles={{
										input: {
											backgroundColor: "#294165",
											color: "white",
										},
										root: {
											width: "50%",
											color: "white",
										},
									}}
								/>
							</Center>

							<Center pl={0} ml={0} mt={10}>
								<TextInput
									className="labelAddUser"
									placeholder="User Email"
									label="UserEmail"
									{...form.getInputProps("Email")}
									mr={10}
									styles={{
										input: {
											backgroundColor: "#294165",
											color: "white",
										},
										root: {
											width: "50%",
											color: "white",
										},
									}}
								/>

								<NativeSelect
									className="labelAddUser"
									label="Role"
									{...form.getInputProps("Role")}
									placeholder="Role"
									data={["Admin", "Viewer", "Creator"]}
									styles={{
										input: {
											backgroundColor: "#294165",
											color: "white",
											fontSize: "0.8rem",
										},
										root: {
											width: "50%",
											color: "white",
										},
									}}
									rightSection={<IconChevronDown size={14} />}
									rightSectionWidth={40}
								/>
							</Center>
						</Grid.Col>
						<Grid.Col md={0} lg={1}></Grid.Col>
						<Grid.Col span={4}>
							<MediaQuery
								smallerThan="sm"
								styles={{
									marginTop: "0px",
									marginLeft: "50px",
								}}
							>
								<Button
									ml={30}
									mt={92}
									style={{
										width: "60%",
										color: "black",
										borderRadius: "8px",
										fontSize: "small",
									}}
									type="submit"
								>
									Add User
								</Button>
							</MediaQuery>
						</Grid.Col>
					</Grid>
				</form>
			</Container>
			<TeamManagement setLoading={setLoading} />
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default Adduser;
